import Loading from '../../../components/loading';
import styles from './styles.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { useJuror } from '../../../hooks/useAuth';
import { combine } from '../../../helpers/styles';
import { useEffect, useState } from 'react';
import { getLogo } from '../../../helpers/logo';

const Login = () => {
  const [isCheckVisible, setIsCheckVisible] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  const { juror } = useJuror();

  const uuid = id || localStorage.getItem('juror_uuid');

  useEffect(() => {
    if (juror) {
      setTimeout(() => {
        setIsCheckVisible(true);
        setTimeout(() => {
          navigate('/juror/dashboard');
        }, 1500);
      }, 2500);
    }
  }, [setIsCheckVisible, juror]);

  return (
    <div className={styles.login}>
      <div className={styles.topContainer}>
        <div className={styles.imageContainer}>
          <img
            src={getLogo()}
            className={combine(styles.image, styles.logo)}
            alt={'iF Logo'}
          />
          {juror?.profilePictureUrl && (
            <img
              src={juror.profilePictureUrl}
              className={combine(styles.image, styles.profilePicture)}
              alt={'Juror Profile Picture'}
            />
          )}
        </div>
        {juror && (
          <div className={styles.greetingsContainer}>
            <span>
              <Trans
                i18nKey="jurorLogin.welcome.message"
                components={{ bold: <b /> }}
                values={{
                  name: juror.firstname,
                }}
              />
            </span>
          </div>
        )}
      </div>
      <div className={styles.bottomContainer}>
        {!uuid ? (
          <h4>{t('jurorLogin.noID.message')}</h4>
        ) : !isCheckVisible ? (
          <Loading />
        ) : (
          <div className={styles.check}></div>
        )}
      </div>
    </div>
  );
};

export default Login;
